'use es6';

import { createSelector } from 'reselect';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import { List } from 'immutable';
const selectRoot = get('dashboards');
export const selectDashboards = createSelector([selectRoot], root => getIn(['dashboards', 'dashboards'], root) || List());